
import { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";

const CookieConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem("zimkonnect_cookie_consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("zimkonnect_cookie_consent", "accepted");
    setShowBanner(false);
    console.log("✅ Cookies accepted");
    // Initialize analytics or other cookies if needed here
  };

  const handleReject = () => {
    localStorage.setItem("zimkonnect_cookie_consent", "rejected");
    setShowBanner(false);
    console.log("🚫 Cookies rejected");
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-white border-t border-gray-200 shadow-2xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <Cookie className="w-5 h-5 text-amber-600 flex-shrink-0" />
            <p className="text-sm text-gray-700">
              We use cookies to improve your experience on ZimKonnect and provide personalized content.
              <a href="/cookies" className="text-blue-600 hover:text-blue-800 underline ml-1">
                Learn more
              </a>
            </p>
          </div>
          
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={handleReject}
              className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Reject
            </button>
            <button
              onClick={handleAccept}
              className="px-4 py-2 text-sm font-medium text-white bg-zim-green hover:bg-green-700 rounded-lg transition-colors flex items-center gap-2"
            >
              Accept Cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
